// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__1rEVD","icon":"styles_icon__8FRU3"};